(function () {
  var DYE_LINKS = {
    'FAM': '/products/fam-dye-spectral-calibration-plate-384-well',
    'SUN': '/products/vic-sun-dye-spectral-calibration-plate-384-well',
    'SUN (VIC)': '/products/vic-sun-dye-spectral-calibration-plate-384-well',
    'Texas Red': '/products/texas-red-dye-spectral-calibration-plate',
    'CY5': '/products/cy5-spectral-calibration-plate',
    'TAMRA': '/products/tamra-dye-spectral-calibration-plate',
    'ATTO550': '/products/atto550-dye-spectral-calibration-plate',
    'ATTO647': '/products/atto647-dye-spectral-calibration-plate',
    'TEX 615': '/products/tex-615-dye-spectral-calibration-plate',
    'YAK': '/products/yakima-yellow'
  };

  var MASTERMIX_LINKS = {
    'PureAmp Express Mastermix': '/products/a2k-pureamp-express-qpcr-mastermix'
  };

  function initKitSelector(root) {
    var buttons = root.querySelectorAll('[data-kit-button]');
    var targetItems = root.querySelectorAll('[data-target]');
    if (!buttons.length || !targetItems.length) return;

    var statsBox = root.querySelector('[data-kit-stats]');

    function setStat(name, value) {
      if (!statsBox) return;
      var field = statsBox.querySelector('[data-stat="' + name + '"]');
      var row = statsBox.querySelector('[data-stat-row="' + name + '"]');
      if (field) field.textContent = value || '';
      if (row) row.style.display = value ? '' : 'none';
    }

    function setFluorophores(value) {
      if (!statsBox) return;
      var field = statsBox.querySelector('[data-stat="fluorophores"]');
      var row = statsBox.querySelector('[data-stat-row="fluorophores"]');
      if (row) row.style.display = value ? '' : 'none';
      if (!field) return;

      field.textContent = '';
      if (!value) return;

      var names = value.split(',').map(function (n) { return n.trim(); }).filter(Boolean);

      names.forEach(function (name, i) {
        var link = DYE_LINKS[name];
        var el = document.createElement(link ? 'a' : 'span');
        if (link) {
          el.href = link;
          el.className = 'a2k-kit-selector__dye-chip';
        } else {
          el.className = 'a2k-kit-selector__dye-chip a2k-kit-selector__dye-chip--plain';
        }
        el.textContent = name;
        field.appendChild(el);
      });
    }

    function setMastermix(value) {
      if (!statsBox) return;
      var field = statsBox.querySelector('[data-stat="mastermix"]');
      var row = statsBox.querySelector('[data-stat-row="mastermix"]');
      if (row) row.style.display = value ? '' : 'none';
      if (!field) return;

      field.textContent = '';
      if (!value) return;

      var link = MASTERMIX_LINKS[value.trim()];
      if (!link) {
        field.textContent = value;
        return;
      }

      var chip = document.createElement('a');
      chip.href = link;
      chip.className = 'a2k-kit-selector__dye-chip';
      chip.textContent = value;
      field.appendChild(chip);
    }

    function applyStats(button) {
      setStat('sku', button.getAttribute('data-sku'));
      setStat('target-count', button.getAttribute('data-target-count'));
      setStat('reactions', button.getAttribute('data-reactions'));
      setStat('module-count', button.getAttribute('data-module-count'));
      setStat('module-list', button.getAttribute('data-module-list'));
      setMastermix(button.getAttribute('data-mastermix'));
      setFluorophores(button.getAttribute('data-fluorophores'));
    }

    function applyKit(button) {
      var raw = button.getAttribute('data-targets') || '';
      var included = raw.split('||').map(function (t) { return t.trim(); }).filter(Boolean);
      var includedSet = {};
      included.forEach(function (t) { includedSet[t] = true; });

      targetItems.forEach(function (item) {
        var name = item.getAttribute('data-target');
        if (includedSet[name]) {
          item.classList.add('is-included');
        } else {
          item.classList.remove('is-included');
        }
      });

      buttons.forEach(function (b) { b.classList.remove('is-active'); });
      button.classList.add('is-active');

      applyStats(button);
    }

    buttons.forEach(function (button) {
      button.addEventListener('click', function () {
        applyKit(button);
      });
    });

    applyKit(buttons[0]);
  }

  document.querySelectorAll('[data-a2k-kit-selector]').forEach(initKitSelector);
})();
